import react from 'react';
import Combaintop from '../Components/Combaintop/Top';
import Combainbottom from '../Components/Combainbottom/Combainbottom';
import AccountSettings from '../Components/User-Dashboard/Setting';
import Breadcrumbs from '../Components/banner/New-banner';

function Settingpage () {
    return(
         <>
        <Combaintop/>
        <Breadcrumbs/>
        <AccountSettings/>
        <Combainbottom/>
        </>
    );
}

export default Settingpage;
